module.exports = "<!-- <div>D3SankyChartComponent</div> -->\r\n<div #sankyChartRef ></div>"